export enum DATE_FORMAT {
  DATE_FORMAT_BACKEND = 'YYYY-MM-DD',
  DATE_FORMAT_DE = 'DD.MM.YYYY',
  DATE_FORMAT_DE_WITHOUT_YEAR = 'DD.MM',
  DATE_FORMAT_US = 'MM/DD/YYYY',
  DATE_FORMAT_US_WITHOUT_YEAR = 'MM/DD',
  DATE_FORMAT_VN = 'DD.MM.YYYY',
  DATE_FORMAT_VN_WITHOUT_YEAR = 'DD.MM',
}
